/* KOMTO: доработка виджета отзывов Judge.me (revamp, Vue).
   1. «Отзыв для Sofia 60» → карточка товара с фото и ссылкой (данные из
      предиктивного поиска Shopify: /search/suggest.json — без зависимости от
      внутренностей Judge.me).
   2. Одна строка-раскрытие про перенесённые отзывы в шапке виджета — вместо
      плашки на каждом отзыве.
   Работает через MutationObserver: виджет перерисовывается при сортировке и
   пагинации, поэтому дорабатываем каждый новый узел, а не один раз. */
(function () {
  'use strict';
  var cfg = (document.querySelector('script[data-komto-reviews]') || {}).dataset || {};
  var root = cfg.root || '/';
  if (root.slice(-1) !== '/') root += '/';   // routes.root_url для локалей = "/ru" без слэша
  var LABEL = cfg.labelReviewFor || 'Review for';
  var NOTE = cfg.note || '';
  var CURRENT = (cfg.currentTitle || '').trim();
  var CURRENT_HANDLE = (cfg.currentHandle || '').toLowerCase();
  var cache = {};
  // Decimal mark of the language (komto-decimal: «0.5» on English, «0,5» elsewhere) for Judge.me's average rating
  var DEC = (cfg.decimal || '0.5').charAt(1) || '.';



  // Judge.me считает позиции masonry один раз, а картинки в отзывах приезжают
  // позже: карточка растёт, соседняя остаётся на старом месте и они налезают.
  // В одну колонку это видно сразу. Штатного пересчёта наружу нет, но на resize
  // виджет раскладывает заново. `load` не всплывает — слушаем в фазе перехвата.
  var komtoRelayoutTimer = null;
  function komtoRelayout() {
    if (komtoRelayoutTimer) clearTimeout(komtoRelayoutTimer);
    komtoRelayoutTimer = setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 150);
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('#judgeme_product_reviews')) {
      komtoRelayout();
    }
  }, true);


  function lookup(title) {
    if (cache[title]) return cache[title];
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(title) +
      '&resources[type]=product&resources[limit]=5&resources[options][fields]=title';
    cache[title] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        var exact = list.filter(function (p) { return (p.title || '').trim().toLowerCase() === title.toLowerCase(); })[0];
        return exact || list[0] || null;
      })
      .catch(function () { return null; });
    return cache[title];
  }

  function enhanceProductCards(scope) {
    var cards = scope.querySelectorAll('.jm-product-variant-card:not([data-komto])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-komto', '1');
      var link = card.querySelector('.jm-product-variant-card__product-link');
      if (!link) return;
      var title = (link.textContent || '').trim();
      if (!title) return;
      // отзыв о самом этом товаре — карточка не несёт информации
      if (CURRENT && title.toLowerCase() === CURRENT.toLowerCase()) { card.style.display = 'none'; return; }
      lookup(title).then(function (p) {
        if (!p) return;
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        var a = document.createElement('a');
        a.className = 'komto-rev-prod';
        a.href = root + 'products/' + p.handle;   // без хвостов предиктивного поиска
        a.innerHTML =
          (img ? '<img src="' + img + '" alt="" width="56" height="56">' : '') +
          '<span class="komto-rev-prod__text">' +
            '<span class="komto-rev-prod__lbl">' + LABEL + '</span>' +
            '<span class="komto-rev-prod__title">' + p.title + '</span>' +
          '</span>';
        card.innerHTML = '';
        card.appendChild(a);
        card.classList.add('komto-rev-prod-wrap');
        komtoRelayout();
      });
    });
  }

  function addNote(scope) {
    if (!NOTE || !(parseInt(cfg.count, 10) > 0)) return;  // no «brought over from Amazon» line under zero reviews (16d)
    var widget = scope.closest ? (scope.closest('#judgeme_product_reviews') || scope.querySelector('#judgeme_product_reviews')) : null;
    widget = widget || document.querySelector('#judgeme_product_reviews');
    if (!widget || widget.querySelector('.komto-rev-note')) return;
    var title = widget.querySelector('.jm-review-widget-minimal-header__title, .jm-review-widget__header [role="heading"]');
    if (!title) return;
    var host = title.parentElement;
    var p = document.createElement('p');
    p.className = 'komto-rev-note';
    p.textContent = NOTE;
    host.appendChild(p);
  }


  // --- Старый виджет (несгруппированные товары) ---------------------------
  // Строка «about <товар>» приходит текстом. Тот же товар, что открыт, — прячем;
  // другой — та же карточка с фото, что и в новом виджете. Название берём из
  // /products/<handle>.js, а не из ссылки: Judge.me хранит его таким, каким оно
  // было в момент отзыва, и оно бывает устаревшим.
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function handleOf(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? m[1].toLowerCase() : '';
  }
  function enhanceLegacyCards(scope) {
    var wraps = scope.querySelectorAll('.jdgm-rev__prod-info-wrapper:not([data-komto])');
    Array.prototype.forEach.call(wraps, function (w) {
      w.setAttribute('data-komto', '1');
      var link = w.querySelector('.jdgm-rev__prod-link');
      if (!link) return;
      var handle = handleOf(link.getAttribute('href'));
      if (!handle) return;
      var row = w.parentElement && w.parentElement.classList.contains('jdgm-row-product') ? w.parentElement : w;
      if (handle === CURRENT_HANDLE) { row.style.display = 'none'; return; }
      fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          var a = document.createElement('a');
          a.className = 'komto-rev-prod';
          a.href = root + 'products/' + p.handle;
          a.innerHTML =
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') +
            '<span class="komto-rev-prod__text">' +
              '<span class="komto-rev-prod__lbl">' + esc(LABEL) + '</span>' +
              '<span class="komto-rev-prod__title">' + esc(p.title) + '</span>' +
            '</span>';
          w.classList.remove('jdgm-hidden');
          w.innerHTML = '';
          w.appendChild(a);
          w.classList.add('komto-rev-prod-wrap');
        })
        .catch(function () {});
    });
  }

  var pending = false;
  // Модалка одиночного отзыва (jdgm-modal) — портал в body, Vue пишет её цвета
  // как inline style при каждой отрисовке (--jm-review-widget-*-color: #186138,
  // фирменный зелёный Judge.me), поэтому CSS-переопределение с !important не
  // побеждает: перезаписываем те же CSS-переменные через JS сразу после рендера.
  var MODAL_VARS = {
    '--jm-review-widget-star-and-histogram-color': '#BA8A61',
    '--jm-review-widget-button-color': '#302E2B',
    '--jm-widget-primary-color': '#BA8A61',
    '--jm-review-widget-form-button-color': '#302E2B'
  };
  function fixModalColors(scope) {
    var modals = scope.querySelectorAll ? scope.querySelectorAll('.jdgm-modal') : [];
    Array.prototype.forEach.call(modals, function (modal) {
      for (var k in MODAL_VARS) modal.style.setProperty(k, MODAL_VARS[k]);
    });
  }

  // Judge.me prints the average as «4.2» on every language; the rest of the site writes «4,2» where the language
  // does (mobile-product-fixes, BAN-179). Only a bare one-decimal number is touched.
  function localiseAverage(widget) {
    if (DEC === '.') return;
    var nodes = widget.querySelectorAll('.jm-average-rating-display .jm-text, .jdgm-rev-widg__summary-average');
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.children.length) return;
      var t = n.textContent;
      var legacy = n.classList.contains('jdgm-rev-widg__summary-average');
      if (legacy || /^\s*\d\.\d\s*$/.test(t)) n.textContent = t.replace(/(\d)\.(\d)/, '$1' + DEC + '$2');
    });
  }

  // Judge.me writes dates as «26/07/2026» and a nameless reviewer as «Anonymous» on every language, and has no
  // setting for either (hotfix 4, BAN-179): the date becomes «26.07.2026» everywhere, the name follows the page
  // language (products.reviews.anonymous). Only a text node that is exactly such a date or exactly «Anonymous» inside
  // Judge.me markup is touched. Fixed in the observer callback itself (before paint, so no flash of the old text) and
  // on the text node in place, so Vue keeps it on re-render; when Vue writes a new value it is fixed again.
  var ANON = cfg.anonymous || '';
  var JDGM = '#judgeme_product_reviews, [class*="jdgm"], [class*="jm-"]';
  var DATE_RE = /^(\s*)(\d{2})\/(\d{2})\/(\d{4})(\s*)$/;
  function fixText(node) {
    var el = node.parentElement;
    var t = node.nodeValue;
    if (!el || !t || t.length > 40 || !el.closest(JDGM)) return;
    if (DATE_RE.test(t)) {
      node.nodeValue = t.replace(DATE_RE, '$1$2.$3.$4$5');
    } else if (ANON && ANON !== 'Anonymous' && t.trim() === 'Anonymous' && /name|author/i.test(el.className || '')) {
      node.nodeValue = t.replace('Anonymous', ANON);
      if (el.getAttribute('title') === 'Anonymous') el.setAttribute('title', ANON);
    }
  }
  function fixTree(root) {
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 || /^(SCRIPT|STYLE|TEMPLATE)$/.test(root.tagName)) return;
    if (!root.closest(JDGM) && !root.querySelector(JDGM)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) fixText(n);
  }
  var textMo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'characterData') fixText(r.target);
      else for (var j = 0; j < r.addedNodes.length; j++) fixTree(r.addedNodes[j]);
    }
  });
  textMo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  fixTree(document.body || document.documentElement);

  function run() {
    pending = false;
    var widget = document.querySelector('#judgeme_product_reviews');
    if (widget) {
      enhanceProductCards(widget);
    enhanceLegacyCards(document);
      addNote(widget);
      localiseAverage(widget);
    }
    fixModalColors(document);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(run, 60);
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  // страховка на случай, если виджет дорисовал узлы без мутаций, которые мы поймали
  var ticks = 0;
  var iv = setInterval(function () { schedule(); if (++ticks > 20) clearInterval(iv); }, 1000);

})();
